import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _taggedTemplateLiteral from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useQuery as useGQLQuery, useLazyQuery } from '@apollo/client';
import dayjs from 'dayjs';
import gql from 'graphql-tag';
import { useCallback, useMemo } from 'react';
import { BranchConstants } from 'src/constants';
import { BranchVisitStates } from 'src/types';
import { GetBranchVisitsByDateRangeQueryGQL } from './BranchVisit';
export var SearchQueryGQL = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query SearchQuery($text: String, $mobile: String, $branch_id: Int) {\n    clients(\n      where: {\n        _or: [\n          { mobile: { _ilike: $mobile } }\n          { real_name: { _ilike: $text } }\n          { org_client_profiles: { real_name: { _ilike: $text } } }\n          { org_client_profiles: { record_number: { _like: $text } } }\n          { org_client_profiles: { identity_number: { _like: $text } } }\n        ]\n        _and: [{ org_client_profiles: { branch_id: { _eq: $branch_id } } }]\n      }\n    ) {\n      name\n      real_name\n      mobile\n      birthday\n      identities(where: { provider: { _eq: \"mobile\" } }) {\n        uid\n      }\n      org_client_profiles(where: { branch_id: { _eq: $branch_id } }) {\n        real_name\n        mobile\n        org_id\n        identity_number\n        record_number\n        gender\n        client_id\n        birthday\n      }\n    }\n  }\n"])));
var SearchClientIdGQL = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  query SearchClientByIdQuery($id: Int) {\n    clients(where: { id: { _eq: $id } }) {\n      id\n      name\n      real_name\n      gender\n      identity_number\n      org_client_profiles {\n        identity_number\n        record_number\n        gender\n      }\n    }\n  }\n"])));
var SearchClientIdByUidGQL = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  query SearchClientIdByUidQuery($uuid: String) {\n    clients(where: { uuid: { _eq: $uuid } }) {\n      id\n      uuid\n    }\n  }\n"])));
export var useSearchClientByUuid = function useSearchClientByUuid(uuid) {
  var _useGQLQuery = useGQLQuery(SearchClientIdByUidGQL, {
    variables: {
      uuid: uuid
    },
    skip: !uuid
  }),
      data = _useGQLQuery.data,
      loading = _useGQLQuery.loading,
      refetch = _useGQLQuery.refetch;

  var client = useMemo(function () {
    var _data$clients;

    return data === null || data === void 0 ? void 0 : (_data$clients = data.clients) === null || _data$clients === void 0 ? void 0 : _data$clients[0];
  }, [data]);
  return {
    refetch: refetch,
    client: client,
    loading: loading
  };
};
export var useSearchClientById = function useSearchClientById() {
  var _useLazyQuery = useLazyQuery(SearchClientIdGQL),
      _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
      mutateFunction = _useLazyQuery2[0],
      _useLazyQuery2$ = _useLazyQuery2[1],
      data = _useLazyQuery2$.data,
      loading = _useLazyQuery2$.loading,
      error = _useLazyQuery2$.error;

  var clients = useMemo(function () {
    return data === null || data === void 0 ? void 0 : data.clients.map(function (client) {
      var _client$org_client_pr, _client$org_client_pr2, _client$org_client_pr3, _client$org_client_pr4, _client$org_client_pr5, _client$org_client_pr6;

      return _objectSpread(_objectSpread({}, client), {}, {
        name: client === null || client === void 0 ? void 0 : client.name,
        real_name: client === null || client === void 0 ? void 0 : client.real_name,
        gender: (client === null || client === void 0 ? void 0 : (_client$org_client_pr = client.org_client_profiles) === null || _client$org_client_pr === void 0 ? void 0 : (_client$org_client_pr2 = _client$org_client_pr[0]) === null || _client$org_client_pr2 === void 0 ? void 0 : _client$org_client_pr2.gender) || (client === null || client === void 0 ? void 0 : client.gender),
        identity_number: (client === null || client === void 0 ? void 0 : (_client$org_client_pr3 = client.org_client_profiles) === null || _client$org_client_pr3 === void 0 ? void 0 : (_client$org_client_pr4 = _client$org_client_pr3[0]) === null || _client$org_client_pr4 === void 0 ? void 0 : _client$org_client_pr4.identity_number) || (client === null || client === void 0 ? void 0 : client.identity_number),
        record_number: client === null || client === void 0 ? void 0 : (_client$org_client_pr5 = client.org_client_profiles) === null || _client$org_client_pr5 === void 0 ? void 0 : (_client$org_client_pr6 = _client$org_client_pr5[0]) === null || _client$org_client_pr6 === void 0 ? void 0 : _client$org_client_pr6.record_number
      });
    });
  }, [data]);
  var applySearch = useCallback(function (id) {
    mutateFunction({
      variables: {
        id: Number(id)
      }
    });
  }, [mutateFunction]);
  return {
    applySearch: applySearch,
    clients: clients,
    loading: loading,
    error: error
  };
};
export var useSearchRecentVisitClients = function useSearchRecentVisitClients() {
  var startDate = dayjs().subtract(3, 'day');
  var endDate = dayjs();

  var _useLazyQuery3 = useLazyQuery(GetBranchVisitsByDateRangeQueryGQL),
      _useLazyQuery4 = _slicedToArray(_useLazyQuery3, 2),
      mutateFunction = _useLazyQuery4[0],
      _useLazyQuery4$ = _useLazyQuery4[1],
      data = _useLazyQuery4$.data,
      loading = _useLazyQuery4$.loading,
      error = _useLazyQuery4$.error;

  var clients = useMemo(function () {
    return data === null || data === void 0 ? void 0 : data.branch_visits.map(function (visit) {
      var _visit$client, _visit$client2, _visit$client3, _visit$client4, _visit$client4$org_cl, _visit$client4$org_cl2, _visit$client5, _visit$client6, _visit$client6$org_cl, _visit$client6$org_cl2, _visit$client7, _visit$client8, _visit$client8$org_cl, _visit$client8$org_cl2;

      return _objectSpread(_objectSpread({}, visit), {}, {
        id: (visit === null || visit === void 0 ? void 0 : visit.client_id) || (visit === null || visit === void 0 ? void 0 : (_visit$client = visit.client) === null || _visit$client === void 0 ? void 0 : _visit$client.id),
        name: visit === null || visit === void 0 ? void 0 : (_visit$client2 = visit.client) === null || _visit$client2 === void 0 ? void 0 : _visit$client2.name,
        real_name: visit === null || visit === void 0 ? void 0 : (_visit$client3 = visit.client) === null || _visit$client3 === void 0 ? void 0 : _visit$client3.real_name,
        gender: (visit === null || visit === void 0 ? void 0 : (_visit$client4 = visit.client) === null || _visit$client4 === void 0 ? void 0 : (_visit$client4$org_cl = _visit$client4.org_client_profiles) === null || _visit$client4$org_cl === void 0 ? void 0 : (_visit$client4$org_cl2 = _visit$client4$org_cl[0]) === null || _visit$client4$org_cl2 === void 0 ? void 0 : _visit$client4$org_cl2.gender) || (visit === null || visit === void 0 ? void 0 : (_visit$client5 = visit.client) === null || _visit$client5 === void 0 ? void 0 : _visit$client5.gender),
        identity_number: (visit === null || visit === void 0 ? void 0 : (_visit$client6 = visit.client) === null || _visit$client6 === void 0 ? void 0 : (_visit$client6$org_cl = _visit$client6.org_client_profiles) === null || _visit$client6$org_cl === void 0 ? void 0 : (_visit$client6$org_cl2 = _visit$client6$org_cl[0]) === null || _visit$client6$org_cl2 === void 0 ? void 0 : _visit$client6$org_cl2.identity_number) || (visit === null || visit === void 0 ? void 0 : (_visit$client7 = visit.client) === null || _visit$client7 === void 0 ? void 0 : _visit$client7.identity_number),
        record_number: visit === null || visit === void 0 ? void 0 : (_visit$client8 = visit.client) === null || _visit$client8 === void 0 ? void 0 : (_visit$client8$org_cl = _visit$client8.org_client_profiles) === null || _visit$client8$org_cl === void 0 ? void 0 : (_visit$client8$org_cl2 = _visit$client8$org_cl[0]) === null || _visit$client8$org_cl2 === void 0 ? void 0 : _visit$client8$org_cl2.record_number
      });
    });
  }, [data]);
  var applySearch = useCallback(function (text) {
    mutateFunction({
      variables: {
        text: "%".concat(text, "%"),
        start_date: startDate.startOf('date').toISOString(),
        end_date: endDate.endOf('date').toISOString(),
        branch_id: BranchConstants.BRANCH_ID,
        exclude_state: BranchVisitStates.canceled,
        booking_source_names: BranchConstants.BOOKING_SOURCE_NAMES
      }
    });
  }, [mutateFunction, startDate, endDate]);
  return {
    applySearch: applySearch,
    clients: clients,
    loading: loading,
    error: error
  };
};